(() => {
  const AGE_KEY = 'glasgow:age-confirmed:v1'
  const AGE_TTL_MS = 30 * 24 * 60 * 60 * 1000

  const root = document.querySelector('[data-age-gate]')
  if (!root || root.dataset.bound === 'true') return
  root.dataset.bound = 'true'

  const readStored = () => {
    try {
      return window.localStorage.getItem(AGE_KEY)
    } catch {
      return null
    }
  }

  const writeStored = (value) => {
    try {
      window.localStorage.setItem(AGE_KEY, value)
    } catch {
      // Storage unavailable (private mode, quota, or disabled).
    }
  }

  const parseTimestamp = (value) => {
    if (!value) return null
    const parsed = Number.parseInt(value, 10)
    return Number.isFinite(parsed) ? parsed : null
  }

  const isAgeConfirmed = (now) => {
    const timestamp = parseTimestamp(readStored())
    if (timestamp === null) return false
    return now - timestamp < AGE_TTL_MS
  }

  document.body.appendChild(root)

  if (isAgeConfirmed(Date.now())) return

  const confirmButton = root.querySelector('[data-age-confirm]')
  const inertNodes = []
  let scrollLocked = false

  const lockPage = () => {
    document.documentElement.style.overflow = 'hidden'
    scrollLocked = true
    for (const node of document.body.children) {
      if (node === root || node.inert) continue
      node.inert = true
      inertNodes.push(node)
    }
  }

  const unlockPage = () => {
    if (scrollLocked) {
      document.documentElement.style.overflow = ''
      scrollLocked = false
    }
    while (inertNodes.length > 0) {
      const node = inertNodes.pop()
      node.inert = false
    }
  }

  const onKeyDown = (event) => {
    if (root.hidden) return
    if (event.key === 'Escape') {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    if (event.key !== 'Tab') return
    event.preventDefault()
    if (confirmButton) confirmButton.focus()
  }

  const onPageHide = () => {
    unlockPage()
  }

  const onPageShow = () => {
    if (!root.hidden) lockPage()
  }

  const closeGate = () => {
    root.hidden = true
    unlockPage()
    document.removeEventListener('keydown', onKeyDown, true)
    window.removeEventListener('pagehide', onPageHide)
    window.removeEventListener('pageshow', onPageShow)
  }

  lockPage()
  root.classList.add('age-gate--enter')
  root.hidden = false
  document.addEventListener('keydown', onKeyDown, true)
  window.addEventListener('pagehide', onPageHide)
  window.addEventListener('pageshow', onPageShow)

  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      writeStored(String(Date.now()))
      closeGate()
    })
    confirmButton.focus()
  } else {
    root.focus()
  }
})()
